import { render, staticRenderFns } from "./ReportByAgeAndWeekTotal.vue?vue&type=template&id=816870ec"
import script from "./ReportByAgeAndWeekTotal.vue?vue&type=script&lang=js"
export * from "./ReportByAgeAndWeekTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports